import { render } from "./eventLayout.vue?vue&type=template&id=71d3fe39"
import script from "./eventLayout.vue?vue&type=script&lang=js"
export * from "./eventLayout.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__